export default __webpack_public_path__ + "static/media/hidden.07b1d8f4.gif";